module.exports = __webpack_public_path__ + "static/media/FinanceDash.5b6a96c4.png";